import React from 'react';
import Signup from '../components/auth/Signup';

const SignupPage: React.FC = () => {
  return <Signup />;
};

export default SignupPage;
